import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import Clickable from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon from "@insite/mobius/Icon";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import exportTerms from "@tKgpco/Handlers/Terms/ExportTerms";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";
import { QuoteTermsFormValues } from "@tKgpco/Store/Data/Terms/TermsState";
import React, { useContext, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapDispatchToProps = {
    exportTerms,
};

const mapStateToProps = (state: CustomApplicationState) => ({
    selectedTermIds: state.KGPState.customTerms.selectedTermIds,
    selectFilter: state.KGPState.customTerms.selectFilter,
    selectFilterText: state.KGPState.customTerms.selectFilterText,
    isAllTermSelected: state.KGPState.customTerms.isAllTermSelected,
});

interface CustomWidgetStyles {
    wrapper?: InjectableCss;
}

const styles: CustomWidgetStyles = {};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const ExportTerms: React.FC<Props> = ({ 
    id,
    exportTerms,
    selectedTermIds,
    selectFilter,
    selectFilterText,
    isAllTermSelected }) => {
    const [isExporting, setIsExporting] = useState(false);
    const toasterContext = useContext(ToasterContext);

    const handleExport = () => {
        if (isExporting) {
            return;
        }

        const TermsIds = Object.keys(selectedTermIds);
        const QuoteTermIds:string[]=[];
        TermsIds.forEach((id) => {
            QuoteTermIds.push(id)
        });
        let filters= {}
        if(isAllTermSelected) {
            filters = { [selectFilter as keyof QuoteTermsFormValues]: selectFilterText }
        } else {
            filters = { [selectFilter as keyof QuoteTermsFormValues]: selectFilterText, QuoteTermIds}
        }

        exportTerms({ queryParams: filters, onSuccess: onUploadingSuccess });
    };

    const onUploadingSuccess = () => {
        setIsExporting(false);
        toasterContext.addToast({ body: translate("Terms exported successfully"), messageType: "success" });
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <Clickable onClick={handleExport} title="Export Terms">
                <Icon src="Download" size={20} />
            </Clickable>
        </StyledWrapper>
    );
};

const importTermsWidget: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ExportTerms),
    definition: {
        group: "Basic",
    },
};

export default importTermsWidget;
